window.reviews = [
{
  "name": "David B.",
  "date": "September 21, 2026",
  "title": "20,000 Miles of Adventures!",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/1203/5870/files/db20k.png?v=1790014726",
  "video": "",
  "html5video": "",
  "comment": "Our two Fat Tads have served us well these last eight years. They helped me overcome back issues, moving me from the couch onto a back-friendly recumbent trike. As a result, we've been able to travel all over the Central U.S., exploring many trails, great and small. Thanks for your part in our journey as we cross this 20,000-mile milestone shown in the attachment.",
  "response": "David, congratulations on an incredible 20,000-mile milestone! Eight years of riding, exploring trails across the Central U.S., and putting those two Fat Tads to work is quite a journey. We're especially glad the recumbent design helped you get back outside and enjoy riding comfortably again. Thank you for allowing ElectricTrike.com to be part of your adventures. Here's to many more miles and trails ahead!"
},
{
  "name": "Kevin",
  "date": "September 2, 2026",
  "title": "20 Miles of Confidence with the New LCD!",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/1203/5870/files/Kevin-eco-tad-review.png?v=1777990503",
  "video": "",
  "html5video": "",
  "comment": "Just wanted to let you know we took the trikes out today for a 20 mile spin around Morraine state park and the new LCD worked flawless! I love the 10% incremental readings on the battery, it gives me much more confidence in the distance I can travel. Thank you again for the great service and very reasonable prices. Hope to see you on the trail someday!",
  "response": "Kevin, this is awesome to hear! We're glad the new LCD is giving you that extra confidence on your rides—those battery increments really make a difference on longer trips. Sounds like a perfect day out at Moraine State Park. Thanks again for your kind words about the service and pricing—we truly appreciate it. Hope to see you out on the trail as well!"
},
{
  "name": "Vivian L.",
  "date": "August 22, 2026",
  "title": "Me and My Schnickers",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/1203/5870/files/vivianp-Fat-Tad-Electric-Trike.png?v=1764969594",
  "video": "",
  "html5video": "",
  "comment": "I have 3 Fat Tads and thinking of a fourth! I would like to keep 2 at each of my homes so that a friend can also ride along with me and my dog Schnickers. Everyone who rides thinks these are the bomb! One even purchased her own from ElectricTrike.com. Palm Coast, Florida has over 200 miles of bike paths and this trike gets so MANY comments. I tell them it is like riding down the trail on a recliner! LOL",
  "response": "Vivian, this absolutely made our day! Three Fat Tads — and now thinking about a fourth — is the highest compliment we could ever receive. We're thrilled to hear how much joy the trikes bring to you, your friends, and of course Schnickers. With all those beautiful miles of bike paths in Palm Coast, we're glad the Fat Tad continues to be the perfect 'recliner on wheels.' Thank you for sharing the love and for being such an amazing ambassador for ElectricTrike.com!"
},
{
  "name": "Alan S.",
  "date": "June 30, 2026",
  "title": "10,000 Miles and Counting!",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/1203/5870/files/Alan-S10kET.png?v=1757703063",
  "video": "",
  "html5video": "",
  "comment": "🌟 10,000 MILES and COUNTING! 🌟\n\nSay hello to Alan Stein of Aurora, Colorado — and give him a big round of applause! 🎉 Alan just crossed 10,000 miles on his Sun Seeker T3 CX electric trike, riding loops around the Aurora Reservoir and beyond.\n\nThat’s right — ten thousand miles of fresh air, freedom, and unforgettable rides.\n\nAlan’s journey is what #TrikeLife is all about: movement, independence, and joy at your own pace. He’s not just racking up miles — he’s setting the bar for what’s possible with a reliable, full-size electric trike.\n\n📍 “From Aurora to the South Pole and 37 miles further…”\n\n — Alan Stein",
  "response": "Alan, this is absolutely incredible — congratulations on hitting 10,000 miles! Your dedication, consistency, and passion for riding inspire all of us. The Sun Seeker T3 CX was made for exactly this kind of freedom and discovery. Thank you for taking us along for the journey — from Aurora to the South Pole and beyond!"
},
{
  "name": "John B.",
  "date": "April 23, 2026",
  "title": "91 and Still Riding Strong!",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/1203/5870/files/JohnB-Electric-Eco-Tad-Recumbent-Testimonial.png?v=1754071748",
  "video": "",
  "html5video": "",
  "comment": "I’m a 91 year old avid bike rider. Been riding for 20 to 25 years. When my doctor recommended 3 wheels I bought the Eco Tad with electric assist. I call it my cardio leg machine. I live in a retirement community in Frisco, Texas. Love getting outside and enjoying fresh air and exercising on my trike.",
  "response": "John, you're an inspiration! We're honored that the Eco Tad with electric assist is helping you stay active and continue doing what you love. Calling it your 'cardio leg machine' is perfect—and we’re so glad it’s keeping you moving and enjoying the outdoors in Frisco. Wishing you many more fresh-air rides ahead!"
},
{
  "name": "Glen B.",
  "date": "February 24, 2026",
  "title": "Enjoy the View and Exercise Too!",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/1203/5870/files/GlenB-Electric_Fat-Tad-Recumbent-MT.png?v=1745859285",
  "video": "",
  "html5video": "",
  "comment": "I’m 75 years old and never really liked sitting on a two wheel bike seat because of the discomfort. I had ridden two wheel recumbent bikes before with the comfortable seat but I liked the idea of three wheels for ease of balance. I ordered a Sun CSX FAT TAD trike from ElectricTrike.com and when I received it I was very impressed with the way it was boxed, wrapped and ready to ride! The only thing I had to do was adjust the handlebars and seat to my preference and it was easy. We have a local bike path here in Montana that runs from Hamilton to Missoula along the Bitterroot River, about 50 miles, and it’s beautiful so I went for my first short ride and really enjoyed it. What I noticed is how I saw things I had never seen before because when you're in a car you're just wizzing by everything. I felt like I was one with the environment looking at water and rocks and flowers and other things I had never noticed. I found trails I didn’t know were there and even rode in a sandy river bottom because my trike had fat tires and electric assist to help me through. I stopped at a store along the path and bought some jerky so I had a good chew as I pedaled along. Then I stopped at the river's edge and just enjoyed the sun, river, rocks and sand all from my recliner-type chair. No worries about getting up or down hills with pedal assist and even throttle if I didn’t want to pedal! Now my trike is parked in my garage waiting for our next adventure. I do want to say that Jason at ElectricTrike.com is an amazing guy who answers the phone and has answered any minor questions I had. He really is a great guy!",
  "response": "Glen, your story absolutely made our day! It's wonderful to hear how much you're enjoying your Sun Fat-Tad CXS and discovering so much more of your beautiful surroundings. Riding along the Bitterroot River sounds like an incredible experience, and we're honored to be part of your adventures. Thank you for sharing your journey and for the kind words—Jason and the whole team are always here to help whenever you need us. Here's to many more rides filled with new discoveries and great memories!"
},
{
  "name": "Louis S.",
  "date": "December 15, 2025",
  "title": "Follow My Fat Tad Adventures!",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/1203/5870/files/Smitty-Electric_Fat-Tad-Recumbent.png?v=1745860654",
  "video": "",
  "html5video": "",
  "comment": "I bought my Sunseeker Fat Tad etrike from ElectricTrike.com in 2024 and have been riding the Fatty often. I ride in the Southwest deserts of New Mexico and this Fat Tad exceeds my expectations without a doubt. This trike takes me on adventures that I would have never done without the electrical assist. See me on YouTube under Tadpole Smitty Sunseeker Fat Tad!",
  "response": "Thank you, Smitty! We love seeing your adventures out in the beautiful Southwest with your Fat Tad. Your YouTube channel is a fantastic resource for anyone wanting to see what the Fat Tad can really do. We encourage everyone to check out your videos and follow your adventures at https://www.youtube.com/@robertsmith2419. Keep on riding and inspiring others!"
},
{
  "name": "Richard F.",
  "date": "October 10, 2025",
  "title": "Outstanding Customer Service and Perfect Trike!",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/1203/5870/files/RichF-Electric_Recumbent_Delta_Trike_-_PA.png?v=1745859531",
  "video": "",
  "html5video": "",
  "comment": "I spent months contacting dozens of potential e-trike vendors. None were able to answer questions or provide assistance in meeting my specific requirements (I needed complete left-handed operability). I discovered ElectricTrike.com and found the perfect answer to my search. I purchased a 21-speed recumbent trike which gave me the option of pedal or electric power. It rides and looks great! Outstanding customer service, tremendous technical knowledge, complete attention to detail, large variety of models and great competitive pricing makes ElectricTrike.com the best place to buy your next ride.",
  "response": "Richard, we truly appreciate your thoughtful review and are thrilled to hear that you found exactly what you needed at ElectricTrike.com! Meeting unique needs like complete left-handed operability is exactly why we take a personalized approach to every customer. Thank you for recognizing our team's dedication to service, technical expertise, and variety. Wishing you countless enjoyable miles on your new recumbent trike!"
},
{
  "name": "Cindy C.",
  "date": "August 22, 2025",
  "title": "New Trike, New Adventures!",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/1203/5870/files/CindyC-Liberty-Trike.png?v=1731007049",
  "video": "",
  "html5video": "",
  "comment": "My trike came today! It took a couple of hours to get it unboxed and be sure we put it together correctly. The battery was mostly fully charged. Nice surprise Liberty Trike! 💙 So I rode it up and down the driveway and in the yard very slowly and carefully. It’s going to be a learning curve to ride it but it feels much better than my non-electric trike. I need to get a helmet before we go camping next week. We’re taking our camper out one last time before putting it to bed for the winter. It’s cold 🥶 here today, 57° but cloudy and feels colder. So I need to go in for a bit. But so far I think I’m going to LOVE it! Thank you Linda Starnes for bringing yours out last weekend for me to try. That was very helpful! 🥰",
  "response": "We're so glad to hear your new trike arrived safe and sound, Cindy, and you're already getting a feel for it. It's wonderful that Linda could give you a first-hand look last weekend—it really helps to try one out! Enjoy your camping trip and here's to many cozy, adventurous rides with your new trike. Stay warm and have fun!"
},
{
  "name": "Tom",
  "date": "June 30, 2025",
  "title": "Loving My Recumbent!",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/1203/5870/files/Toms-Electric-Tri-Classic.png?v=1729625917",
  "video": "",
  "html5video": "",
  "comment": "Dear Linda & Nicole, Contrary to my first thought of changing models, (driving you crazy!), I love my Electronic Technologies Recumbent! Thank you so much for your help in the purchase and assistance getting started.",
  "response": "Thank you for your kind words, Tom! We're delighted to hear that you've grown to love your Electronic Technologies Recumbent and that Linda and Nicole were able to assist you so effectively. Enjoy your rides, and we're here whenever you need further support or just want to share more of your recumbent adventures!"
},
{
  "name": "Alan",
  "date": "April 28, 2025",
  "title": "9,000 Miles of Joy!",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/1203/5870/files/Alan-Electric-T3-Review.png?v=1727293115",
  "video": "",
  "html5video": "",
  "comment": "This is a photo of me with my Sunseeker CX T3 just moments after I completed 9,000 miles! And basically all 9,000 miles were ridden around the Aurora Reservoir, which is about 2 miles from my house in Aurora, Colorado (just outside of Denver). And as I mentioned in my previous email, the distance from Denver to the South Pole is 8,963 miles. I just rode 37 more miles than that! After looking at a TON of reviews I finally decided the CX T3. I unpacked my trike on August 12, 2019 and I have been riding every day, weather permitting. Winter months here in Colorado not so much! This Sun Seeker has been the most remarkable, efficient, carefree trike I have ever owned. Actually, it’s the ONLY trike I’ve ever owned! Haha. But it’s ease of handling, the balance, the power when I need it—all of this is beautifully contained in this sleek and elegant and incredible ride. And it’s all thanks to you guys at ElectricTrike, who have supported me all along the way, especially when I was having my battery issue. The absolute BEST team and BEST customer service, and I cannot thank you enough for all that you have done.",
  "response": "Alan, what an outstanding milestone! We're so proud to hear how well the Sunseeker CX T3 has served you, especially on your amazing journeys around the Aurora Reservoir. Reaching 9,000 miles is no small feat, and it sounds like the trike has been a perfect match for your adventures. Thank you for acknowledging our team's effort to support you, particularly through your battery issue. We look forward to celebrating the next big milestone with you — here's to 10,000 miles! Have a fantastic Labor Day Weekend!"
},
{
  "name": "Marco P.",
  "date": "February 7, 2025",
  "title": "Trike Fishing Success!",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/1203/5870/files/MarcoP-Fat-Trike-Electric_0bec8e91-713c-484a-80f3-86e55c6ed274.png?v=1727295265",
  "video": "",
  "html5video": "",
  "comment": "Here is my last article just to let you know next month I’m gonna be featuring the trike. I’ve been using it every day to fish and I’m batting 1000. It gives me much bigger range than I’ve had in the past and goes over the soft sand no problem. I’ll be in touch. Ya mon, Marco Pompano",
  "response": "Marco, that's fantastic to hear! We're excited to learn that the trike has been a game changer for your fishing adventures, enhancing your range and handling challenging terrains like soft sand effortlessly. We look forward to your feature next month and hearing more about your successful outings. Keep enjoying the rides and tight lines, ya mon!"
},
{
  "name": "Terry F.",
  "date": "December 19, 2024",
  "title": "Milestone Achieved on My Eco-TAD SX!",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/1203/5870/files/TerryF-Electric-Eco-Tad.png?v=1727294733",
  "video": "",
  "html5video": "",
  "comment": "Milestone Achieved! [Update: Please ignore the \"Trip\" meter - I never reset it and it reads the same as the odometer] I reached my first goal of 100 miles on my Sun Electric Eco-TAD SX during my afternoon ride today. While that may seem trivial to some who ride 20-30 miles per day, it was a significant achievement for me. I purchased my trike from ElectricTrike.com and have only been riding a few weeks. I typically ride only in my very hilly subdivision in East Tennessee that has as much as a 15% grade. Eighteen of my first 100 miles were gained through numerous trips up a hill with an average 6% grade. Total elevation gain for the 100 miles was 3.2 miles. My primary objective for riding is physical conditioning, and 3.5-7 mile rides in hilly terrain serves to accomplish that.",
  "response": "Congratulations on hitting the 100-mile mark, Terry! It's fantastic to hear about your progress and how the Sun Electric Eco-TAD SX is helping you achieve your fitness goals. Tackling those hills, especially with such steep grades, is no small feat, and it's inspiring to hear how you've embraced the challenge. Keep up the great work, and we look forward to hearing about your next milestone!"
},
{
  "name": "Lynn T. C.",
  "date": "October 2, 2024",
  "title": "Thrilled with Gypsy Rose!",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/1203/5870/files/LynnC-Electric-Adult-Fat_trike.png?v=1727294548",
  "video": "",
  "html5video": "",
  "comment": "Got my new Fat Trike and I could not be more pleased with her! The shipping cost sounded a little steep to me, but when I saw how carefully she was packed, it was worth EVERY SINGLE PENNY! And all of the accessories were already installed! Oh my gosh! Literally, all I had to do was step on and pedal away. I'm looking forward to a lot of adventures with Gypsy Rose!",
  "response": "Lynn, we're so happy to hear that you're pleased with your new Fat Trike, Gypsy Rose! It sounds like she was ready for adventure right from the start. We take great care in packaging our trikes to ensure they arrive in perfect condition and are thrilled that this detail didn't go unnoticed. Here's to many wonderful adventures ahead, and thank you for trusting us with your new journey!"
},
{
  "name": "David S.",
  "date": "September 21, 2024",
  "title": "Sunny CA Beach Ride!",
  "score": 5,
  "image": "",
  "video": "",
  "html5video": "https://cdn.shopify.com/videos/c/o/v/58a2844789a84642a4d1b852e9e4c4ee.mp4",
  "comment": "Nice sunny day for a CA beach ride with Josie Rodriguez-Smith on her Eco Tad Trike.— at Huntington Beach Pier.",
  "response": "David, thanks for sharing your beach day adventure! It sounds like a perfect day to take the Eco Tad Trike out for a spin at Huntington Beach. We're thrilled you and Josie had such a great time enjoying the sun and the scenery. Here's to many more sunny rides down the coast!"
},
{
  "name": "Karl D.",
  "date": "September 9, 2024",
  "title": "Great Adventures with Fat-Tad CXS!",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/1203/5870/files/KarlD-Electric-Trike-Fat-Tad.png?v=1727293365",
  "video": "",
  "html5video": "",
  "comment": "I'm really liking my Fat-Tad CXS I got from Electric Trikes in Croydon, PA 19021. Here are a few pics from my trips in NJ and Delaware.",
  "response": "Thank you for sharing, Karl! It's fantastic to hear that you're enjoying your Fat-Tad CXS and making the most of it on your adventures in NJ and Delaware. We're thrilled that your trike is taking you places and providing great experiences. Keep the adventures coming and let us know about your future journeys!"
},
{
  "name": "Rick P.",
  "date": "September 8, 2024",
  "title": "Innovative Solution for Fat-Tad CXS!",
  "score": 3,
  "image": "https://cdn.shopify.com/s/files/1/1203/5870/files/rickP-Electric-Fat-Tad-Recumbent.png?v=1727293582",
  "video": "",
  "html5video": "",
  "comment": "My Fat-Tad dumped my fat butt on the bike trail when I attempted a tight u-turn at very low speed. IMHO, having the battery mounted above my shoulders on the rear rack raises the center of gravity too high. So, I just finished 3D printing a 10ah battery rack that mounts under the seat using the front and rear seat mounting holes.",
  "response": "Hi Rick, thanks for sharing your experience. We want to let you know that we've taken feedback like yours to heart. In response, all new Fat-Tad models now feature battery mounting hardware that positions the battery very low, close to the frame, significantly improving the center of gravity and overall stability. This update should alleviate the issues you experienced. We encourage you to check out the product page here for the Fat-Tad to see what the new setup looks like and how we've addressed these concerns. Your feedback has been crucial in helping us make these improvements!"
},
{
  "name": "Betsy A. Honsen",
  "date": "April 14, 2024",
  "title": "Freedom and Joy in Riding",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/1203/5870/files/BetsyH-Electric-Eco-Tad.jpg?v=1713098610",
  "video": "",
  "html5video": "",
  "comment": "My 91 year old husband rides the Sunseeker tadpole, and I enjoy my Townie step thru. All the \"I can'ts\" have disappeared!😁🤗",
  "response": "Betsy, it’s wonderful to hear how you and your husband are enjoying your rides! It's inspiring to see that age is just a number when it comes to enjoying life and staying active. Your enthusiasm and positive spirit are truly contagious. Keep riding and spreading joy!"
},
 {
    name: "Mike T.",
    date: "August 9, 2023",
    title: "Exceptional Service!",
    score: 5,
    image:
      "https://cdn.shopify.com/s/files/1/1203/5870/files/mikeT-electric-Eco-Delta-SX.jpg?v=1689779638",
    video: "",
    html5video: "",
    comment:
      "Here are a few pics of Sue enjoying her new electric recumbent bike. Your tech guys did a super job getting braking and controls on the left side. Thanks for accommodating her needs.",
    response:
      "Thank you, Mike! We're thrilled to hear that Sue is enjoying her new electric recumbent bike. At ElectricTrike.com, we always strive to customize our products to fit our customers' unique needs. We hope Sue has many fun and safe rides ahead. Let us know if there's anything else we can assist with in the future!",
  },
  {
    name: "Retta P.",
    date: "July 22, 2023",
    score: 5,
    image:
      "https://cdn.shopify.com/s/files/1/1203/5870/files/332771002_681925960286604_9213338051504862157_n.jpg?v=1677253356",
    title: "What a blast!",
    comment:
      'My wife & I bought the Electric Fat Trike from electrictrike.com for "practical" reasons:  We travel in an RV and wanted a smaller vehicle to run campground errands without buying a small car to tow behind our rig.  We also wanted this trike to tow our little "honeywagon" to the dump station without the hassle of breaking camp and driving the motorhome for such a short trip.  We added a 3-ramp Easy Load Tray from easyloadrampsystem.com to the back of our RV and presto!  No tow car required  :-) What I didn not expect was how much fun it is to ride this trike, and I find myself taking it out for a spin every chance I get just for pleasure.  It is a great system -- I really like the way you can adjust how much work the motor does, so you only pedal as much as you want. It took me a few minutes to learn what you need to do when making sharp turns (hint: pretend it is a catamaran boat) but everything else was super easy.  Pre-assembled, ready to ride, simple controls, gorgeous -- what\'s not to love?.  Buy it for "practical" reasons if you must.  Keep it for the fun!',
  },

  {
    name: "Cissy",
    date: "July 2, 2023",
    score: 5,
    image:
      "https://cdn.shopify.com/s/files/1/1203/5870/files/Screenshot_2022-11-30_at_10.22.54_AM.png?v=1669822224",
    title: "Is Perfect For Me!",
    comment:
      "The three biggest factors I purchased the electric Fat Trike from Electrictrike.com is that it comes fully assembled, the cost, and I've been in touch with one of their customers who had such good things to say about this particular trike… plus customer service.<br><br>I’m 76 years old and cannot ride a two-wheeler any longer. I have always wanted an electric trike. Balance is iffy these days, and the electric fat tire looked perfect for me!",
  },

  {
    name: "Jesse R.",
    date: "June 24, 2023",
    score: 5,
    image:
      "https://cdn.shopify.com/s/files/1/1203/5870/files/Jesse_R_Electric_Trike_2.png?v=1676861654",
    title: "Electric Fat Trike",
    comment:
      "I love my e-trike! I purchased it because I have a disability that doesn't allow me to drive so I drive my fat trike back and forth to work. I work at Moody Gardens in Galveston, Texas and they absolutely love my trike. I also love taking it down the Seawall!",
  },

  {
    name: "Melanie M.",
    date: "June 8, 2023",
    score: 5,
    image:
      "https://cdn.shopify.com/s/files/1/1203/5870/files/178437261_10220005846520422_8531636894053747952_n.jpg?v=1676839736",
    title: "Tricker Chick!",
    comment:
      "I've had my Electric Fat Trike for 15 months and put about 700 miles on it! It has been a lot of fun. I ride as often as I can, which in the summer is hard here, since it is so hot. I am waiting for the weather to get a bit more mild then I plan to get back out on the trails.",
  },

  {
    name: "Eric I.",
    date: "May 19, 2023",
    score: 5,
    image:
      "https://cdn.shopify.com/s/files/1/1203/5870/files/Eric_Irwin_Post_1.png?v=1676862417",
    title: "The only way to go camping!",
    comment:
      "I tell everyone at every campground to only get one from ElectricTrike.com and to not waste their money on a cheap ones. I take it hunting in the woods and make my own trails. This bike is so powerful! I love your product.",
  },

  {
    name: "Barb C.",
    date: "April 28, 2023",
    score: 5,
    image:
      "https://cdn.shopify.com/s/files/1/1203/5870/files/Barb_Coles_Post_2.png?v=1676775450",
    title: "Sunseeker EZ-3",
    comment:
      "I got my electric trike today and couldnt be happier. I have had a Sunseeker EZ-3 USX HD for 17+ years and loved it, but it was getting hard to get up some hills. Was so excited to see ElectricTrike made an electric one. Now to get my old one upgraded for my husband.",
  },

  {
    name: "Dawn R.",
    date: "April 8, 2023",
    score: 5,
    image:
      "https://cdn.shopify.com/s/files/1/1203/5870/files/Dawn_Testimony_3.png?v=1676776022",
    title: "Fantastic Service",
    comment:
      "I have an Electric Fat Trike and really enjoy it! A year ago in June, my husband and I visited your shop with a battery problem, and your service was fantastic! You gave us a new battery under warranty and we also purchased a second one. The extra one is usually always in my cargo bag, as we frequently do rides that run a little tight for one battery. My trike now has over 3400 miles on it since receiving it June 2, 2020. We really enjoy biking, and want to thank you again for the great service we received with the battery issue. We have had no trouble since then. I also receive quite a few compliments on the trike.",
  },

  {
    name: "Edward W.",
    date: "July 8, 2022",
    score: 5,
    image: "",
    video: "https://youtu.be/r_CyDvoIBCY",
    title: 'Blue Electric 24" Traditional Trike',
    comment:
      'I bought a blue Electric 24" Traditional Trike in 2020 . I have the 48v 9 AH battery with the bag and no basket modification. Since my balance is not so good anymore, I cannot see clearly out of my right eye, and I have a damaged heart, this electric trike has been a God send for me to enjoy the freedom of going around the neighborhood and enjoying the outdoors.It has given me back a way to feel mobile again. Thank you to everyone at Electric Bike Technologies.',
  },

  {
    name: "Michael M.",
    date: "June 24, 2022",
    score: 5,
    image:
      "https://cdn.shopify.com/s/files/1/1203/5870/files/fat_tire_trike.png?v=1676862845",
    title: "Less than a year later...",
    comment:
      "Fat trike....less than a year owned. Love in South Florida...it's my sole transportation! 1,100 miles so far....pedal a lot through town as well without pedal assist. Love it!!!",
  },

  {
    name: "Larry W.",
    date: "March 4, 2022",
    score: 5,
    image:
      "https://cdn.shopify.com/s/files/1/1203/5870/files/284146598_10161675923247004_312604712129887742_n.jpg?v=1676428170",
    title: "One Year Later...",
    comment:
      "I am enjoying my electric Fat Trike more now than when I first got it. It's dependable, rugged, fast (when I need it), and good-looking. I have had two warranty issues that the team at EBT took care of quickly and professionally.<br><br>For those of you in cold weather parts of the country... I rode it all winter long in temperatures that dipped into the teens and had no issues. It is my primary mode of transportation, so I need it to be reliable, and it has been.<br><br>If you are considering a fat tire trike for your next purchase, I highly recommend this electric Fat Trike. Plus, the service department is outstanding.",
  },

  {
    name: "Round Paul.",
    date: "November 23, 2021",
    score: 5,
    image: "",
    title: "2 Years and Still Going",
    comment:
      "I've owned my Electric Trike for 2 yrs now and still can't wait to get it out of the garage every morning. I'm a big guy with bad knees and my trusty trike takes me around my property loaded with tools and then a few evening laps of the neighborhood saving me from the pain of walking too far. Other than adjust the brakes, lube the chain and keep the tires inflated, and of course plug it in every few days I haven't had to do much to it, it just works. Very happy with my purchase!!",
  },

  {
    name: "Lynn C.",
    date: "August 12, 2021",
    score: 5,
    image:
      "https://cdn.shopify.com/s/files/1/1203/5870/files/237549386_10224271966959782_3668388966835139910_n_c026a5a9-fb47-46b4-bd38-d5384006ce3e.jpg?v=1676427751",
    title: "Gypsy Rose!",
    comment:
      "Got my new Fat Trike and I could not be more pleased with her! The shipping cost sounded a little steep to me, but when I saw how carefully she was packed, it was worth EVERY SINGLE PENNY! And all of the accessories were already installed! Oh my gosh! Literally, all I had to do was step on and pedal away. I am looking forward to a lot of adventures with Gypsy Rose!",
  },

  {
    name: "Bart M.",
    date: "July 02, 2021",
    score: 5,
    image: "",
    title: "Awesome",
    comment:
      "After developing a balance issue, I had to buy a trike - my Fat Trike is ideal for me since it handles gravel roads and hills extremely well for a guy who is 6’ 1”, 275 pounds, and 72 years old. While I had to learn to lower the speed and go wider in turns, that was the only real adjustment, I had to make riding my electric Fat Trike. So far, I had ridden nearly 500 miles on pavement, dirt, and gravel – both flat and hilly. My Fat Trike can travel 20-25 miles and I'm only using level 2 assist and cruising at 10-12 mph. In short, I love my Fat Trike and look forward to many more miles of riding.",
  },

  {
    name: "Roberta K.",
    date: "June 17, 2022",
    score: 5,
    image:
      "https://cdn.shopify.com/s/files/1/1203/5870/files/Roberta_ET_Testimony_-_FB_1.png?v=1676859697",
    title: "Love My Sun Trike",
    comment:
      "I have a traditional Sun Trike from Electric Trike. I love it and your company!",
  },

  {
    name: "Earl G.",
    date: "May 17, 2021",
    score: 5,
    image: "",
    title: "Excellent Customer Service!",
    comment:
      "The wife and I recently purchased a pair of Eco-Tad SX trikes. They arrived well packaged, safe, and sound. Over the next few days, I identified a couple of minor issues, which Bill in Customer Service promptly dealt with and sent us what was needed. Have no doubts, this is a great company to do business with!",
  },

  {
    name: "Val W.",
    date: "May 24, 2021",
    score: 5,
    image: "",
    title: "Love My Recumbent!",
    comment:
      "I received my bike in February and have already got 550 miles. It is so very comfortable and fun to ride. It came in an amazing crate and it was ready to ride, right out of the box. I have no more sore neck, hands, and knees and I can ZOOM up the hills. We ordered the largest motor and are very glad we did.",
  },

  {
    name: "Larry W.",
    date: "February 12, 2021",
    score: 5,
    image: "",
    title: "So Far, So Good",
    comment:
      "The trike was boxed exactly as the company said it would be. It arrived in what appears to be perfect condition. As it is Feb 12th, I will be waiting for a bit warmer day to install the fenders and adjust the handlebars.It arrived 4 to 5 days earlier than anticipated which is a blessing. I can't wait to get it together so I can ride it! I will leave a follow-up review when that takes place. Thank you EBT!",
  },

  {
    name: "John W.",
    date: "January 16, 2021",
    score: 5,
    image: "",
    title: "Good, Solid Trike",
    comment:
      "I only have 40 miles on my Fat Trike, but there is plenty to love about it. It feels solid and I feel safe riding it. Glad now that I bought a trike that was assembled and tested before taking delivery, as everything was set up and adjusted correctly when I received it. I was worried about power because I am 220 lbs but with a 1/2 battery left, I easily climbed the steepest hill, I could find. The assist settings should be sufficient to please any rider, big or small. I got 20 miles of range and the battery indicator showed about 25% left. I was on setting 2 on the rails to trails. I needed to change the seat out so I got a big wider one on Amazon. That required cutting the lever to lift the seat, but it still works fine. The trike just feels like something that is going to hold up! People admire it, so be ready to provide information on where to get one.",
  },

  {
    name: "Brad P.",
    date: "November 7, 2020",
    score: 5,
    image: "",
    title: "Love My Electric EZ-3 USX HD",
    comment:
      "I purchased my Sun Seeker Electric EZ-3 USX HD in March of 2020 and have enjoyed it immensely since day one. Due to having a co-pilot (my 8 lb. toy Schnauzer), I installed a pair of above the headset recumbent type handlebars so I could hold on to my puppy with one hand and drive at the same time.<br><br>My ride to the nearby park with my puppy riding on my lap has become a daily adventure that we both sincerely appreciate and genuinely enjoy. I have no peace in my house until I've taken our spoiled little buddy on his daily trike ride (and run) at the park.<br><br>I purchased this trike shortly after having bilateral hip replacements for rehabilitation. However, after giving my puppy a short ride around our front yard, I haven't been able to ride without him since the day I received it.<br><br>I already have +/-2,850 miles on my trike and still haven't had to perform any repairs less replacing a set of new tires because I already wore out the tires (to slicks) that I had originally upgraded too. I put 2.75\" x 20\" tires to better accommodate for my weight and to provide just a little additional suspension via tire depth, which worked out very well.<br><br>This trike has unquestionably changed me and my dog's lives for the better. We are now outside every day getting sun and some exercise while enjoying ourselves immensely. I honestly wouldn't sell it for twice what I paid for it. It truly is that enjoyable!",
  },

  {
    name: "Carol T.",
    date: "July 27, 2020",
    score: 5,
    image: "",
    title: "Great Customer Service!",
    comment:
      "I went for a lively 10 mile ride this morning. I’m in love with my trike. Thank you so much for your fast responses on a Sunday. I really appreciated it. You all have a great customer service response. I’ve told probably 20+ people to order their bikes from you. I told them the wait is really worth it. Thanks again.",
  },

  {
    name: "David P.",
    date: "July 19, 2020",
    score: 5,
    image: "",
    title: "Powerhouse Trike",
    comment:
      "This Mid-Drive Fat Trike is by far the best on the market, a real workhorse on the trail, or making every day trips around town. The other trikes have front hub motors the mid-drive Fat trike's motor works very well I would like to see more reviews. But like with any trike, you have the watch your turns. It may not be as stable as others but after a while, you will get familiar with the trike. It's a great trike for doing just about anything. Also, it just begs to be customized. Thank you!",
  },

  {
    name: "Sonya F.",
    date: "July 6, 2020",
    score: 5,
    image: "",
    title: "New Eco-Tad SX Trike",
    comment:
      "Hi, From Nicole to everyone else at Electric Trike, who has helped me buy my Eco-Tad SX Trike, Thank You! I’m 88 years old – 5 foot, 112 pounds and I wanted a smaller, easy to maneuver bike.<br><br>I’m delighted that my Trike arrived in perfect condition and it was easy to adjust — the handlebars, the seat, and length to pedals. In the summers, I live in Vermont and I have been riding around in it for a week now, using only the #1 and #2 electric modes - haven’t needed the #3 or #4... yet. The gears are easy to shift and the trike is quite stable. All to the good, I pedal and whiz along with great ease and pleasure.<br><br>Thanks so much for your help and for making this excellent trike!",
  },

  {
    name: "Suzanne K.",
    date: "June 27, 2020",
    score: 5,
    image: "",
    title: "Love My New Eco-Delta SX Trike",
    comment:
      "Just received my new Eco-Delta SX electric trike... its the bomb! It was all ready and set up just perfectly for my size. I charged it up, got familiar with it (which was easy), and off I went and I did not want to stop riding. I am 70 years old and I love biking but my wrist bothers me due to arthritis, so this was a perfect option for me. I pedaled the whole time while riding no problem in sixth gear on the lowest setting. I love this trike and recommend it to anyone. Also excellent customer service, delivery right to my driveway.",
  },

  {
    name: "Donald S.",
    date: "May 26, 2020",
    score: 5,
    image: "",
    title: "Love the New Step-Through Trike",
    comment:
      "For an 85-year-old with balance and spinal problems and a love of biking, this was the perfect answer. I've used the Step-Through for only a few days since delivery, so I cannot comment on durability. It took about 15 minutes to learn how to ride it but after that, it was great! I have used all 3 modes, motor off pedal only, motor on with just throttle control, and pedal assist that ease in if one's pedaling starts to lag. Seventeen miles so far with about 50% pedaling and only 1/3 of battery power has been used. Here on Cape Cod, we have a lot of short steep hills and the trike eats those up! We have a lot of narrow roads but also a lot of bikers. So my fears about the extra width of the trike were unfounded as local drivers are used to skirting around bikers.<br><br>I hope to have a trouble-free experience but I am encouraged by other reviewer's positive comments about the customer service.",
  },

  {
    name: "Richard S.",
    date: "May 17, 2020",
    score: 5,
    image: "",
    title: "Had Some Initial Problems but Excellent Customer Service",
    comment:
      "I have been riding two-wheel recumbents bikes for 25 years that last 10 with an electric assist. I decided it was time to get a trike. After a lot of research, I landed on Electric Trike. The main reason was that they shipped the bike fully assembled and preconfigured and they had delivered to your door.<br><br>I live on the San Juan Island chain in Washington State. When the delivery company called to schedule delivery, they informed me they didn't deliver to the island and I would have to meet them on the mainland. This was a bit annoying since I paid for home delivery. Luckily, I had a pickup truck and a front loader tractor with forks to get it out of the truck.<br><br>As advertised the bike was ready to ride and after charging the battery, I took it out for a ride. It took a little getting used to but after a couple of rides, I felt comfortable with the Fat Tad trike. However, on the 3rd ride, I started to hear a clicking sound on the right wheel. I couldn't figure it out so kept going. On the 4th ride, it got louder and decided to cut the ride short and go back home. Once home, I discovered that 4 spokes had broken.<br><br>I emailed Electric Trike and they arranged for two new rims to be dropped shipped to me. With the help of a friend, I was able to get the tires on the new rims and I am riding again. You would think with all of these problems I might give less than 5 stars, but the reason is because of the excellent customer service and very timely communications, I received. The measure of any company is how they perform when things don't go well and Electric Trikes and Jason have done great in that regard.",
  },

  {
    name: "Robert P.",
    date: "May 18, 2020",
    score: 5,
    image: "",
    title: "Electric Eco-Tad SX",
    comment:
      "I had a stroke in July 2019. I lost my license because of my stroke. I was looking for a way to get around and exercise. I stumbled upon your site and I'm so glad I did. I bought the Electro Tad SX and absolutely, LOVE IT!<br><br>I've put 300 miles on it since April 1, 2020. I live in Massachusetts and you're either going up a hill or down. I find the electric assist just right, not too hard but not too easy either. My bad leg is getting stronger and I've lost 10 lbs. that I gained after my stroke. I wished I had bought the $366 battery, but being new to electric trikes I didn't realize the advantage. But other than that I couldn't be happier. I have FREEDOM and EXERCISE in one machine and as I said I LOVE IT! Thank you so much.",
  },

  {
    name: "Kenneth L.",
    date: "November 20, 2019",
    score: 5,
    image:
      "https://cdn.shopify.com/s/files/1/0060/3943/7415/files/Delta-Trike-KenL.png?16250",
    title: "Beach Trike!",
    comment:
      "Here’s a picture of my Delta Trike on St. Augustine Beach at Anastasia Island State Park.",
  },

  {
    name: "Sue F.",
    date: "October 31, 2019",
    score: 5,
    image: "",
    title: "Tire Info Good to Know",
    comment:
      "I have used my bike for several trips now and accidentally discovered two factors that I am happy is discovered close to home. #1 when coming up a slight hill that was in the shade and ground wet, the front tire spun out when applying the electric assist. I wasn’t gunning it up the hill, just trying to get where I was going. It also seems that this might happen up a major hill as the front weighs so much less the the back. So I am changing out the tires. In my areas it is wet and slimy in the winter and I need better traction than the standard tires provide. As a minor note, I would not order the basket if I were to do this again.. it gets in the way of everything and makes it even harder to load. I have replaced with a soft sided bike pack.<br> I have had difficulty finding a good solution to load and unload this bike myself (which has been slightly improved by removing the basket) but my friend build a custom ramp that is basically three troughs that allow me to easily lift the front wheel into place without it sliding or rolling. Then easy to lift back into in the troughs (ground level) and roil the whole bike in place. It is perfect. Maybe the company could consider offering such a loading system? I love this trike and hope to ride many 100’s of miles. It has taken some trips to my local bike shop for adjustments but that is true of any bike. Good company, good service.",
  },

  {
    name: "Benjamin K.",
    date: "October 5, 2019",
    score: 5,
    image: "",
    title: "Life Changing!",
    comment:
      "Due to medical issues, I could no longer ride a 2 wheel bike. I needed an alternative to continuing to have the fun and freedom I desired out of life. I met with the folks at Electric Bike Technologies - and found the Fat Delta. The 3 wheel solution was perfect, and the bike was so cool I could not wait to get back out there. Success - I'm out riding and enjoying all the fun and freedom bike riding offers. This trike has plenty of power, is comfortable, and best of all I CAN RIDE IT!! Thank you to Jason and his team - I needed this win. RIDE ON!",
  },

  {
    name: "Alan S.",
    date: "October 10, 2019",
    score: 5,
    image: "",
    title: "Great Trike",
    comment:
      "Great Trike! I built a seat where the back rack is, for my son and my wife uses it to take him to school all the time.",
  },

  {
    name: "Neil L.",
    date: "September 20, 2019",
    score: 5,
    image: "",
    title: "Got My Fat Tad Today!",
    comment:
      "I'm 70 and 6'4\" and on the heavy side of normal. The trike was set up for me after some eImails and a phone call from E-trike to my specifications. It required very little tweeking and worked fine on my first ride. I had it delivered to Archer's Bikes in Mesa, AZ. Scott at Archers did the tweeking and fit it to me. Only major change I would never have thought of was switching the spacers on the steering mount from the top to the bottom of the stack. This made it possible to push the handle bars more forward with out touching the wheels. Thanks Scott and thanks to the people at E-Trike. I'm very happy.",
  },

  {
    name: "Patricia W.",
    date: "September 30, 2019",
    score: 5,
    image: "",
    title: "Showroom Shape!",
    comment:
      "I received my Sun Traditional today in showroom shape. Took it for a short test spin and really enjoyed the experience! Slow and easy does it for now while I learn. Charging the battery now. Will give a review once I gain experience and can better review it. The seat so far seems comfortable and I like the upright feel of pedaling. I also like the stopping power of the brakes. My feeling is that had I gone to a bike shop I could not have had a better experience. Thank you for all the thought that goes into the production of these bikes!",
  },

  {
    name: "Carl S.",
    date: "October 1, 2019",
    score: 5,
    image: "",
    title: "Enjoying My New Ride!",
    comment:
      "Thank you, very much. The trike was delivered this morning, and although I have only had a brief chance to ride it, and have yet to use the motor, I can say that the trike exceeds my expectations. You did a great job setting it up, educated guess or experience, the trike is a good fit. After a quick inspection, I was pedaling down the street. Thanks again and I’m looking forward to enjoying my new ride.",
  },

  {
    name: "Bryan N.",
    date: "October 4, 2019",
    score: 5,
    image: "",
    title: "Fat Tad Trike",
    comment:
      "Bought this recumbent E-trike for my 69 yr old wife who has severe osteoporosis but loves riding bikes. The doctor said, no more bikes. She absolutely loves the e-assist trike. She can go everywhere with it, even on the many jeep trails in the area. The shocks and big tires are a must for her because she has had a number of spinal compression fractures so we need a soft ride. The folks at Electric Trike are very professional and respond quickly to my emails. They built and shipped the trike in the timeframe promised. They understand the need for good public relations and follow-up service after the sale. If you are going to do mostly street riding, I would recommend the slick tires as the knobbies do wear out in 100 miles, if riding mostly on the street. Great product and great company!",
  },

  {
    name: "Curtis W.",
    date: "September 10, 2019",
    score: 5,
    image: "",
    title: "Great Urban + Trike",
    comment:
      "First of all, the forward crank placement makes this machine a dream to pedal. A great blend of recumbent pedal power but not quite a recumbent. The frame, rear wheel assembly, and basket are aluminum. The rear axle of course is steel as well as front forks are steel. Front wheel drive motor while it works if a relatively steep grade is involved you will loose traction and must pedal to assist the climb. This is still a great trike and good commuter and nifty little vehicle for say grocery shopping. Mine came with an insulated carrier box great for cold foods. It comes with side handles will fit in a standard grocery cart when full, hey you’re done shopping! Load it your trike’s rear basket then head on home. The seat is comfortable and has an adjustable backrest, I had to shim the backrest tunes to stop the slipping of the backrest. The brakes are OK but could be a little stronger. On the positive the parking brake handles work well. The color flamboyant green makes this trike really stand out. I mounted two flags because yes, I want to be seen. The folding handlebars help in storage and transportation. So yes, this is a good value and comfortable ride, and it feels much more stable than the standard shorter wheel base thinner tire trikes.",
  },

  {
    name: "Alan S.",
    date: "September 5, 2019",
    score: 5,
    image: "",
    title: "I truly love my T3 CX!!",
    comment:
      "I cannot tell you how much I truly love my T3 CX!! Just a gem of engineering and the ride is fantastic!",
  },

  {
    name: "Ken R.",
    date: "August 20, 2019",
    score: 5,
    image: "",
    title: "I'm in Love",
    comment:
      "I’ve had this Fat Tad trike for over a year and I’m still in love. I live in Canada and I run this thing on and off-road. I ride it hard and it’s had issues. So, I’ve got advice. I bought three of the knobby tires and the fronts were worn thin after 100 miles! The rear is still on the original tire after 750 miles. I replaced the front tires with the slick tread and everything is now perfect. You only need knobbies on the back where the power comes from. Secondly, I bought the middle size battery and the additional large battery in the bag for longer distance. The bag that the battery comes in ripped within days and the battery fell off the bike on a forest trail and was damaged. I ultimately had to purchase a new battery. After two bags ripping I bought an alternative heavy duty bag from a local bike store. But, the combination of two batteries helps me with distance anxiety. Thirdly, the rack that is on the back of the bike does not stand up to off road situations and the weight of the batteries. The screws loosen, the aluminum plates that attach to the hub break and I’ve been broken down in mid trip. Luckily, I bought side panniers and I carry tools, I brought the bike to my car mechanic and he attached the rack more securely. Finally, I upgraded the brakes on the recommendation of my bike mechanic. So, I’ve had issues, but it’s been more than a year and I’m still in love with my Fat Tad. The people at Electrictrike.com were professional at every turn. Buy this trike!",
  },

  {
    name: "Dave N.",
    date: "August 7, 2019",
    score: 5,
    image:
      "https://cdn.shopify.com/s/files/1/1203/5870/files/Electric-Fat-Tad-Sun-tadpole-etrike-DanN.png?8631",
    title: "We Love Them!",
    comment: "My wife and I both have electric trikes now, we love them!",
  },

  {
    name: "Leysa D.",
    date: "June 29, 2019",
    score: 5,
    image:
      "https://cdn.shopify.com/s/files/1/1203/5870/files/65314179_140188010414791_2238565602107064320_n.jpg?v=1676429742",
    title: "Electric Fat Trike",
    comment: "Here is my (aka: The Beast ) love,love love him! 😍🥰🥰",
  },

  {
    name: "David S.",
    date: "October 24, 2018",
    score: 5,
    image:
      "https://cdn.shopify.com/s/files/1/1203/5870/files/davids-electric-eco-tad-recumbent-trike.png?4426679762182218848",
    title: "This Eco-Tad is all about fun!",
    comment:
      "My first sojourn with my EcoTad! I love this thing! I have to modify the back support for the Veltop fairing/canopy, so I just have the fairing on (with the middle removed and the top part lowered) and I got it up to 28 mph, lol. I went 8 miles to a state park, rode all day mostly on just electric, and back home for a total 25 miles with battery to spare(I upgraded to the 20Ah). This machine is all about fun! Weeeeeeeeeeeeeee...",
  },

  {
    name: "Donald S.",
    date: "October 5, 2018",
    score: 5,
    image:
      "https://cdn.shopify.com/s/files/1/1203/5870/files/donalds-electric-traditonal-trike.png?12624492920593870267",
    title: "Wonderful, Wonderful!",
    comment:
      "This trike is the best. It's my third electric bike, first trike. The first used a throttle to power the bike, the second offered 5 settings to increase the power versus exercise. This trike has both. Incredible ride, luxurious seat made for my 81 year old tush and has put these old bones back in the action. I spend 3 months in LA and don't drive here. It's made me free. When I return to Boca Raton Florida I'll get another trike.",
  },

  {
    name: "Kaz C.",
    date: "September 15, 2018",
    score: 5,
    image:
      "https://cdn.shopify.com/s/files/1/1203/5870/files/Kaz-electric-eco-delta-recumbent-trike.png?3736374496133404540",
    title: "It's Perfect",
    comment:
      "I love it. It's perfect for me. This allows me to get around our development quickly since my back went and I can't walk so fast anymore. It's stable and fits me well and has plenty of power. Thanks for a great trike. It's perfect",
  },

  {
    name: "Dan E.",
    date: "September 4, 2018",
    score: 5,
    image:
      "https://cdn.shopify.com/s/files/1/1203/5870/files/Dan_Fat_Tad.jpg?12376768923345626864",
    title: "Far Exceeded My Expectations",
    comment:
      "The box arrived yesterday in perfect condition and we were able to get the Trike out and adjust the handlebars thanks to the YouTube video available to us. I have read the two booklets from front to back from SunSeeker, and as far as they go they are very helpful. The videos were just what I needed! Although I had already stumbled onto much of what was covered, they hit onto everything I had not discovered. I went for my first ride this morning and I want you to know that this trike has already exceeded my expectations.",
  },

  {
    name: "Dave G.",
    date: "September 1, 2018",
    score: 5,
    image:
      "https://cdn.shopify.com/s/files/1/1203/5870/files/IMG_1013.JPG?6576920330698377462",
    title: "1 Year Owner",
    comment:
      'I have had the electric Fat-Tad trike for just under a year and have put 1700 plus miles on it, mostly on paved bicycle trails. I regularly ride 12 to 38 miles per trip and this trike is incredibly comfortable with outstanding torque and power for climbing hills. IMPORTANT: The fat tires produce great "additional" suspension for increased comfort. I have been slowly reducing tire pressure over time and have found only 6 to 7 psi is just fine for pavement riding (that is on the 20 psi OEM tires). My traditional bike experience told me to pump the tires to max inflation for decreased rolling resistance: WRONG! Rolling resistance doesn\'t matter with a 1000 watts of power!! I LOVE this trike and support from the staff is outstanding. I did a typo on a previous review. I added an excellent $30 bicycle computer to mine for better odometer and speed accuracy. On flats and minor hills I change the assist level on the fly to keep my cadence where I want. I only do gear shifts for steeper hills and for starting. ELECTRIC TRIKE.COM IS AWESOME AND STAND BEHIND THEIR PRODUCTS!',
  },

  {
    name: "Tom J.",
    date: "August 22, 2018",
    score: 5,
    image: "",
    title: "A Great Trike at a Great Price!",
    comment:
      "I researched every trike I could find and this one has the best options with the best price. I was worried about ordering it online without first taking it for a test drive. I was pleasantly surprised with the quality of the trike. I was riding it within a few minutes after delivery. I picked the option of having the street tires on the trike. The off road tires were shipped with a small added price. I can’t think of a better value. The customer service is very friendly and professional if you ever contact them for questions.",
  },

  {
    name: "Jackie G.",
    date: "August 12, 2018",
    score: 5,
    image:
      "https://cdn.shopify.com/s/files/1/1203/5870/files/20180509_101915.jpg?11355065715732720985",
    title: "Loving My Fat-Tad",
    comment:
      "I had a stroke and traumatic brain injury last year from an auto accident that has had me in a lot of pain lately. Had my maiden voyage with my Fat Tad and it was great. My feet were crunched though, so I had to pull out the boom a few inches. The builders matched the X-SEAM measurement I gave them, but since my stroke side leg doesn't flex very well, the measurement wasn't accurate. Pulling the boom out resulted in the chain and derailleurs needing adjustments. The folks at ElectricTrike.com made me some videos to show me what to do. Great people. Knowing that the bike is there gives me just about the only joy I experience these days.",
  },

  {
    name: "John W.",
    date: "August 6, 2018",
    score: 5,
    image: "",
    title: "Thank You!",
    comment:
      "All in all, the bike looks terrific! The promotional video doesn't do it justice until it's sitting right in front of me! Good job on the assembly and installing the electronics! Again, Thanks!",
  },

  {
    name: "Roger K.",
    date: "July 28, 2018",
    score: 5,
    image: "",
    title: "Good People",
    comment:
      "EBT processed the order quickly with the trike being delivered in about two weeks. As advertised, I unboxed it, adjusted the seat to fit me, turned the key on, and it was ready to ride. There have been two problems. First, the Dashboard was installed on the left handle bar below the shifter. Couldn’t see it. Also, EBT sent the wrong charger. In both cases EBT CALLED me within minutes of getting the emails. They offered to send the parts to relocate the dashboard to the boom above the bottom bracket and pay a LBS to do the work and they sent a replacement charger very quickly. Good people! My son and I relocated the dashboard to the top of the left grip/shifter using the existing wiring. Best place for it. Now everything is great.",
  },

  {
    name: "Mark T.",
    date: "July 20, 2018",
    score: 5,
    image: "",
    title: "Great Trike",
    comment:
      "I have been a recumbent trike owner and rider since 2009 when I was diagnosed with Parkinson's disease. Up until now it's been tadpoles. They have all been electric assist. This is my first trike with two wheels in the back. It's the best trike I have owned. Smooth, powerful and comfortable. The electric kit was installed by people who care. It meets and exceeds all my needs. It's fun and a pleasure to ride.",
  },

  {
    name: "Dan R.",
    date: "July 13, 2018",
    score: 5,
    image: "",
    title: "Best Trike",
    comment:
      "This trike is the best I've ever seen! Love it, didn't want to put it in the garage!!! Will probably ride every day the weather is nice. Delivery man was very nice",
  },

  {
    name: "Stan H.",
    date: "July 1, 2018",
    score: 4,
    image: "",
    title: "Great Company to Deal With",
    comment:
      "My wife had a minor problem with her new Mint Pearl Sun trike bike and customer service called us on the weekend and resolved the problem right then. Customer service on the week end is unheard of. It a Pleasure doing business with them. Thanks again for your prompt service and I definitely would buy another bike from them.",
  },

  {
    name: "Linda D.",
    date: "June 25, 2018",
    score: 5,
    image: "",
    title: "I love my new sun trike",
    comment:
      "I love my new Electric Sun Trike! It is nice to be able to ride bikes with my family again. Thank you!!!!",
  },

  {
    name: "Trina P.",
    date: "June 21, 2018",
    score: 4,
    image: "",
    title:
      ' ELECTRIC 24" TRADITIONAL - LOVE IT! AND THE CUSTOMER SERVICE WAS AWESOME',
    comment:
      "I have recently purchased the traditional trike, I have had a few chances to ride in my very hilly area and it works like a dream, it's very comfortable and I cannot think of a single downside to this trike, I would highly recommend it. The customer service for setup and delivery was also very good, given the price point on the bike and shipping, the phone calls for setup and updates were much appreciated.",
  },

  {
    name: "Court R.",
    date: "May 12, 2018",
    score: 4,
    image: "",
    title:
      " THE SUN 24″ TRADITIONAL ELECTRIC TRICYCLE IS A PERFECT EXAMPLE OF THIS...",
    comment:
      "One of the greatest aspects of electric bicycles is that they empower people, some of whom might struggle with manual pedaling, to get back outside and ride. It helps them keep up with friends, go further and carry more gear. Adult tricycles are a natural good fit with motorized technology because in my opinion, they are already accommodating people who might struggle with biking. The Sun 24″ Traditional Electric Tricycle is a perfect example of this.",
  },

  {
    name: "Robert W.",
    date: "May 5, 2018",
    score: 5,
    image: "",
    title:
      "Highly recommend this company, they sell a high-quality product with outstanding support.",
    comment:
      "I received my Fat Trike about two weeks ago and I had reservations about buying it from a company in PA. That was settled fast when I saw how well the Bike was shipped and amazed at the customer support. I don’t really know how many hours they work but I got quick replies to my emails and fast telephone support. This is my third electric assist bike but the first Trike. It has taken me a while to get use to but everyday is better. In my hills this Trike really is a high performer. Highly recommend this company, they sell a high-quality product with outstanding support. The support was needed to teach me some of the operations.",
  },
  {
    name: "Jennifer M.",
    date: "April 25, 2018",
    score: 5,
    image: "",
    title: "Excellent product and outstanding customer service!",
    comment:
      "I purchased the T3 CX from Electrictrike.com, and I couldn't be happier with my decision. The trike performs flawlessly, and the customer service team was incredibly helpful throughout the process. Highly recommended!",
  },
  {
    name: "Michael B.",
    date: "April 20, 2018",
    score: 4,
    image: "",
    title: "Great trike, minor assembly issue",
    comment:
      "The trike itself is fantastic and delivers a smooth ride. However, I encountered a minor issue with the assembly instructions. Thankfully, the customer support team was quick to assist and resolve the problem.",
  },
  {
    name: "Sarah L.",
    date: "April 12, 2018",
    score: 5,
    image: "",
    title: "Impressive performance and build quality",
    comment:
      "I've had my Fat Tad trike for a few months now, and it has exceeded my expectations. The trike handles well on various terrains, and the build quality is top-notch. I highly recommend this trike to all adventure enthusiasts!",
  },
  {
    name: "David H.",
    date: "April 3, 2018",
    score: 5,
    image: "",
    title: "Incredible stability and comfort",
    comment:
      "I recently purchased the Electric Fat Trike, and it has been a game-changer. The stability and comfort of the trike make long rides enjoyable and effortless. Kudos to Electrictrike.com for offering such an outstanding product!",
  },
  {
    name: "Emily T.",
    date: "March 22, 2018",
    score: 5,
    image: "",
    title: "Life-changing mobility solution",
    comment:
      "As someone with limited mobility, the Electric Sun Trike has been a blessing. It allows me to move around with ease and regain my independence. The trike is well-built and has given me a new lease on life!",
  },
  {
    name: "Jason K.",
    date: "March 15, 2018",
    score: 4,
    image: "",
    title: "Solid trike, minor battery issue",
    comment:
      "The trike itself is sturdy and reliable. However, I faced a minor issue with the battery capacity. The customer support team was responsive and helped me resolve the problem quickly.",
  },
  {
    name: "Amy R.",
    date: "March 5, 2018",
    score: 5,
    image: "",
    title: "Smooth ride and excellent customer support",
    comment:
      "The Eco-Tad provides a smooth and comfortable ride, even on longer journeys. I had a few queries during the setup process, and the customer support team was knowledgeable and assisted me promptly.",
  },
  {
    name: "Matthew S.",
    date: "February 25, 2018",
    score: 5,
    image: "",
    title: "Top-notch quality and performance",
    comment:
      "I've been riding the Electric 24\" Traditional trike for months now, and it has consistently impressed me with its quality and performance. It's a reliable and enjoyable mode of transportation.",
  },
  {
    name: "Stephanie C.",
    date: "February 18, 2018",
    score: 5,
    image: "",
    title: "Unbeatable value for the price",
    comment:
      "I did extensive research before buying the trike, and Electrictrike.com offered the best value for the price. The trike exceeded my expectations, and I'm thrilled with my purchase.",
  },
  {
    name: "Brian F.",
    date: "February 10, 2018",
    score: 4,
    image: "",
    title: "Great trike, some minor assembly issues",
    comment:
      "The trike itself is fantastic, providing a smooth ride. However, I faced a few minor challenges during the assembly process. Nonetheless, the customer support team was helpful, and I'm happy with the overall experience.",
  },
  {
    name: "Jessica W.",
    date: "January 28, 2018",
    score: 5,
    image: "",
    title: "Exceptional trike for commuting",
    comment:
      "I use the Electric Fat Tad for my daily commute, and it has been outstanding. The power and stability make it perfect for navigating city streets. I couldn't be happier!",
  },
  {
    name: "Kevin D.",
    date: "January 20, 2018",
    score: 5,
    image: "",
    title: 'Thrilled with the Electric 24" Traditional',
    comment:
      'The Electric 24" Traditional trike has been a joy to ride. It provides a comfortable and stable experience, and I appreciate the excellent customer service from Electrictrike.com.',
  },
  {
    name: "Rachel P.",
    date: "January 12, 2018",
    score: 5,
    image: "",
    title: "Fantastic trike for seniors",
    comment:
      "I purchased the Electric Sun Trike for my elderly father, and it has been a game-changer for him. It offers stability, ease of use, and gives him the freedom to explore the outdoors once again.",
  },
  {
    name: "Greg M.",
    date: "January 5, 2018",
    score: 4,
    image: "",
    title: "Reliable trike, minor cosmetic issue",
    comment:
      "The Electric Fat Tad performs excellently, and the ride is smooth. However, there was a minor cosmetic issue with the frame upon delivery. The customer support team promptly addressed the concern.",
  },
  {
    name: "Melissa H.",
    date: "December 28, 2017",
    score: 5,
    image: "",
    title: "Outstanding trike, exceptional support",
    comment:
      "I've had my T3 CX for a few months now, and I'm thoroughly impressed with its performance and build quality. Electrictrike.com offers exceptional customer support and made the entire buying process a breeze.",
  },
  {
    name: "Robert B.",
    date: "December 20, 2017",
    score: 5,
    image: "",
    title: "Exceptional trike, exceeded expectations",
    comment:
      'The Electric 24" Traditional trike has exceeded my expectations in every aspect. The ride is smooth, and the battery performance is impressive. I highly recommend it!',
  },
  {
    name: "Laura S.",
    date: "December 12, 2017",
    score: 5,
    image: "",
    title: "Perfect trike for leisurely rides",
    comment:
      "The Electric Sun Trike provides a comfortable and enjoyable riding experience. It's perfect for leisurely rides and exploring scenic routes. I'm extremely satisfied with my purchase.",
  },
  {
    name: "Daniel L.",
    date: "December 5, 2017",
    score: 4,
    image: "",
    title: "Great trike, minor battery issue",
    comment:
      "The Electric Fat Tad delivers on its promises with a smooth ride and powerful performance. However, I encountered a minor issue with the battery, which was quickly resolved by the helpful customer support team.",
  },
  {
    name: "Kimberly R.",
    date: "November 28, 2017",
    score: 5,
    image: "",
    title: "Excellent trike, great value",
    comment:
      "The Electric 24\" Traditional trike offers excellent value for the price. It's reliable, comfortable, and has made my daily commute a breeze. Highly recommended!",
  },
  {
    name: "Thomas J.",
    date: "November 20, 2017",
    score: 5,
    image: "",
    title: "Thrilled with the Fat Tad",
    comment:
      "The Electric Fat Tad has been a fantastic investment. It delivers outstanding performance, and the customer support team has been exceptionally helpful. I couldn't be happier!",
  },
];
